import Menu from "../../../components/Menu"

import styles from "./Dochadzka.module.sass"


const App = ({ className }) => {



  return (
    <div className={styles.overlay}>
      <Menu typ="dochadzka" />
    </div>
  );
};
export default App;
